import Konva from "konva";
import React from "react";
import { Rect } from "react-konva";

import { HotspotProps } from "./Hotspot";
import Label from "./Label";
import { useMarchingBorder } from "./useMarchingBorder";

const RectangleHotspot = (props: HotspotProps) => {
  const kovnaRef = React.useRef<Konva.Rect>(null);
  useMarchingBorder(kovnaRef, !!props?.data?.props?.isAnimated);

  const composition = props?.data?.props?.isInverted
    ? "difference"
    : "source-over";

  return (
    <>
      <Rect
        globalCompositeOperation={composition}
        ref={kovnaRef}
        x={props.data.coords.x}
        y={props.data.coords.y}
        width={props.data.coords.w}
        height={props.data.coords.h}
        {...props}
      />
      {props.label && (
        <Label
          text={props.label}
          x={props.data.coords.x + props.data.coords.w / 2 - 15}
          y={props.data.coords.y + props.data.coords.h / 2}
        />
      )}
    </>
  );
};

export default RectangleHotspot;
